const hexToRgb = (hex) => {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits (e.g. #03F)
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  }
  // 6 digits (e.g. #0033FF)
  else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }

  return [r, g, b];
};

const getLuminance = (rgb) => {
  const [r, g, b] = rgb.map((value) => {
    const normalized = value / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : Math.pow((normalized + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const isDark = (hexColor) => {
  const rgb = hexToRgb(hexColor);
  const luminance = getLuminance(rgb);

  return luminance < 0.5 ? 'white' : 'black';
};
